import { ref } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-34a651e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "screen-list-singn"
};
const _hoisted_2 = {
  class: "product-list"
};
const _hoisted_3 = {
  style: {
    "max-height": "900px",
    "margin-right": "20px",
    "overflow-y": "auto",
    "width": "600px"
  }
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "8px"
  }
}, "重新上传", -1));
const _hoisted_6 = {
  style: {
    "text-align": "right",
    "margin-top": "100px"
  }
};
const _hoisted_7 = {
  key: 1,
  class: "screen-list"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "8px"
  }
}, "重新上传", -1));
const _hoisted_10 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_11 = {
  style: {
    "text-align": "right",
    "margin-top": "100px"
  }
};
const _hoisted_12 = {
  key: 2,
  class: "screen-content"
};
const _hoisted_13 = {
  class: "upload-screen-img"
};
const _hoisted_14 = {
  class: "title-content"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传1张截屏", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "所有商品共用该截屏", -1));
const _hoisted_17 = {
  class: "upload-title-content"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode(" 将文件拖动到此处，或 "), /*#__PURE__*/_createElementVNode("span", null, "点击上传")], -1));
const _hoisted_19 = {
  class: "upload-screen-img"
};
const _hoisted_20 = {
  class: "title-content"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传多张截屏", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "每个商品对应不同截屏", -1));
const _hoisted_23 = {
  class: "upload-title-content"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "require"
}, "点击上传"), /*#__PURE__*/_createTextVNode(" 前请将截屏按对应内购ID命名 ")], -1));
const _hoisted_25 = ["src"];
import { awaitWrap, OK } from '@/common';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
import { message } from 'ant-design-vue'; /*  */
import { isArray } from 'lodash';
import { PlusOutlined } from '@ant-design/icons-vue';
// import type { UploadProps } from 'ant-design-vue';
import { submitAuditScreenshot } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    selectedRowKeys: null,
    prodChnl: null
  },
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const previewImage = ref('');
    const previewVisible = ref(false);
    const previewTitle = ref('');
    const selectedList = ref([]); // 选中的商品列表
    const signLoad = ref(false); // 上传一张截图
    const signLoads = ref(false); // 上传多张截图
    const spinning = ref(false); // 上传时 loading
    // 获取图片比例
    // 先获取图片宽高
    // const getFileWidthAndHeight = (file: any, initwidth: number, initheight: number) => {
    //   return new Promise<{ width: number; height: number }>((resolve, reject) => {
    //     const width = initwidth;
    //     const height = initheight;
    //     const _URL = window.URL || window.webkitURL;
    //     const img = new Image();
    //     img.src = _URL.createObjectURL(file);
    //     img.onload = function () {
    //       console.log(
    //         img.width,
    //         img.height,
    //         `上传尺寸最小${initwidth}px * ${initheight}px!`
    //       );
    //       if (img.width < width || img.height < height) {
    //         message.error(`上传尺寸最小${initwidth}px * ${initheight}px!`);
    //         reject();
    //       } else {
    //         resolve(true);
    //       }
    //     };
    //   });
    // };
    // 单张
    const upLoadImg = ref([]);
    // 多张
    const upLoadImgs = ref({});
    const beforeUpload = file => {
      // 图片大小不能超过 5mb
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M && props.prodChnl == 'harmony') {
        message.error('图片大小不能超过 5MB!');
        return false;
      }
      return new Promise((resolve, reject) => {
        const width = 1242;
        const height = 2688;
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = () => {
          // 只有鸿蒙限制照片尺寸
          if ((img.width < 640 || img.height < 920) && props.prodChnl == 'harmony') {
            message.error(`上传尺寸至少为640*920`);
            return false;
          }
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 将canvas上的图片转换为Blob对象
          canvas.toBlob(blob => {
            if (blob === null) {
              reject(new Error('无法创建图片Blob对象'));
              return; // 如果blob为null，则不继续执行后面的代码
            }
            // 创建一个新的File对象，用于上传
            // 把file.name 里面.png 后缀的改成.jpg 后缀
            let newname = file.name.replace(/\.[^/.]+$/, '.jpg');
            const fileOfBlob = new File([blob], newname, {
              type: 'image/jpeg'
            });
            // 将处理后的图片添加到上传列表
            upLoadImg.value = [...(upLoadImg.value || []), fileOfBlob];
            resolve(fileOfBlob); // 使用处理后的图片对象进行上传
          }, 'image/jpeg');
        };
        img.onerror = () => {
          reject(new Error('图片加载失败'));
        };
      });
    };
    // 单张上传
    const signUpload = async ({
      file
    }) => {
      signLoad.value = true;
      signLoads.value = false;
      let formData = new FormData();
      formData.append('file', file);
      formData.append('businessType', 'APPLE_SCREEN_APPROVAL');
      formData.append('businessId', file.name.substring(0, file.name.length - 4));
      try {
        spinning.value = true;
        const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
        if (res) {
          if (res.code === OK) {
            upLoadImg.value = [];
            message.success('导入成功');
            upLoadImg.value.push({
              ...res.data,
              uid: res.data.randomFilename,
              name: res.data.originalFilename,
              status: 'done',
              pictype: 'success',
              url: res.data.fileUrl,
              files: res.data,
              prodId: res.data.prodId
            });
          } else {
            message.error(res.msg);
          }
        }
        if (err) {}
      } finally {
        spinning.value = false;
      }
    };
    // 多张上传
    const signUploads = async ({
      file
    }) => {
      signLoad.value = false;
      signLoads.value = true;
      let formData = new FormData();
      formData.append('file', file);
      formData.append('businessType', 'APPLE_SCREEN_APPROVAL');
      let businessId = '';
      if (isArray(props.selectedRowKeys)) {
        // file.name 去掉最后 4 位字符
        let item = props.selectedRowKeys.find(item => item === file.name.substring(0, file.name.length - 4));
        businessId = item;
        if (item) {
          formData.append('businessId', businessId);
        } else {
          return false;
        }
      } else {
        formData.append('businessId', props.selectedRowKeys);
      }
      try {
        spinning.value = true;
        const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
        if (res) {
          upLoadImgs.value[businessId] = [];
          if (res.code === OK) {
            message.success('导入成功');
            upLoadImgs.value[businessId].push({
              ...res.data,
              uid: res.data.randomFilename,
              name: res.data.originalFilename,
              status: 'done',
              pictype: 'success',
              url: res.data.fileUrl,
              files: res.data
            });
          }
        }
        if (err) {}
      } finally {
        spinning.value = false;
      }
    };
    const beforeitemUpload = (file, fileList) => {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M && props.prodChnl == 'harmony') {
        message.error('图片大小不能超过 5MB!');
        return false;
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        const _URL = window.URL || window.webkitURL;
        img.src = _URL.createObjectURL(file);
        img.onload = () => {
          // 只有鸿蒙限制照片尺寸
          if ((img.width < 640 || img.height < 920) && props.prodChnl == 'harmony') {
            message.error(`上传尺寸至少为640*920`);
            reject(false);
            return;
          }
          let item = props.selectedRowKeys.find(item => item === file.name.substring(0, file.name.length - 4));
          if (item) {
            resolve(true);
          } else {
            reject(false);
          }
        };
        img.onerror = () => {
          reject(new Error('图片加载失败'));
        };
      });
    };
    // 多张重新上传
    const itemUpload = async ({
      file
    }) => {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('businessType', 'APPLE_SCREEN_APPROVAL');
      let businessId = '';
      if (isArray(props.selectedRowKeys)) {
        // file.name 去掉最后 4 位字符
        let item = props.selectedRowKeys.find(item => item === file.name.substring(0, file.name.length - 4));
        businessId = item;
        if (item) {
          formData.append('businessId', businessId);
        } else {
          // upLoadImgs.value[(file.name.substring(0, file.name.length - 4))][0].status = 'removed'
          // return false
        }
      } else {
        formData.append('businessId', props.selectedRowKeys);
      }
      try {
        spinning.value = true;
        const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
        if (res) {
          upLoadImgs.value[businessId] = [];
          if (res.code === OK) {
            message.success('导入成功');
            upLoadImgs.value[businessId].push({
              ...res.data,
              uid: res.data.randomFilename,
              name: res.data.originalFilename,
              status: 'done',
              pictype: 'success',
              url: res.data.fileUrl,
              files: res.data
            });
          }
        }
        if (err) {}
      } finally {
        spinning.value = false;
      }
    };
    const itemChange = a => {
      for (let i in upLoadImgs.value) {
        var _upLoadImgs$value$i$;
        if (((_upLoadImgs$value$i$ = upLoadImgs.value[i][0]) === null || _upLoadImgs$value$i$ === void 0 ? void 0 : _upLoadImgs$value$i$.uid) === a.file.uid) {
          upLoadImgs.value[i] = [];
        }
      }
    };
    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
    const reUpload = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || file.preview;
      previewVisible.value = true;
      previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
    };
    const submitUpload = async () => {
      const params = {
        dbtId: props.dbtId,
        prodChnl: props.prodChnl,
        screenshotReqVos: [],
        prodInfos: selectedList.value.map(item => {
          return {
            prodId: item.prodId,
            prodType: item.prodType,
            id: item.id
          };
        })
      };
      // 单张上传
      if (signLoad.value) {
        if (upLoadImg.value.length <= 0) {
          message.error('请上传截屏');
          return;
        }
        params.screenshotReqVos = props.selectedRowKeys.map(item => {
          return {
            prodId: item,
            remoteFileName: upLoadImg.value[0].remoteFileName,
            fileUrl: upLoadImg.value[0].url,
            fileSize: upLoadImg.value[0].fileSize
          };
        });
      } else if (signLoads.value) {
        // 多张上传
        // 判断 upLoadImgs.value的每个 item 是否不为空数组
        for (let i in upLoadImgs.value) {
          if (upLoadImgs.value[i].length <= 0) {
            message.error('请上传截屏');
            return;
          }
          ;
          params.screenshotReqVos.push({
            prodId: i,
            remoteFileName: upLoadImgs.value[i][0].remoteFileName,
            fileUrl: upLoadImgs.value[i][0].url,
            fileSize: upLoadImgs.value[i][0].fileSize
          });
        }
      }
      try {
        spinning.value = true;
        const res = await submitAuditScreenshot(params);
        if (res.code == 0) {
          if (res.data.failProdIds.length > 0) {
            let str = '';
            upLoadImg.value = [];
            res.data.failProdIds.forEach(item => {
              // 换行
              str += item + '\n';
              upLoadImgs.value[item] = [];
            });
            message.error(str + '上传失败');
            if (signLoad.value) {
              signLoad.value = false;
            }
          } else {
            message.success('上传成功');
            spinning.value = false;
            closeModal();
          }
        } else {
          message.error(res.msg);
        }
      } catch (e) {} finally {
        spinning.value = false;
      }
    };
    const openModal = data => {
      if (isArray(props.selectedRowKeys)) {
        props.selectedRowKeys.forEach(item => {
          upLoadImgs.value[item] = [];
        });
      } else {
        upLoadImgs.value[props.selectedRowKeys] = [];
      }
      selectedList.value = data;
    };
    const handleCancel = () => {
      previewVisible.value = false;
      previewTitle.value = '';
    };
    const closeModal = () => {
      if (spinning.value) return;
      upLoadImgs.value = {};
      upLoadImg.value = [];
      signLoad.value = false;
      signLoads.value = false;
      emit('update:modalVisible', false);
      emit('searchData');
    };
    expose({
      openModal
    });
    return (_ctx, _cache) => {
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_upload_dragger = _resolveComponent("a-upload-dragger");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        centered: "",
        title: "上传截屏",
        width: "800px",
        footer: false,
        onCancel: closeModal
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: spinning.value
        }, {
          default: _withCtx(() => [signLoad.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectedRowKeys, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item,
              style: {
                "margin-bottom": "12px",
                "color": "#000000d9",
                "display": "inline-block",
                "width": "70%"
              }
            }, _toDisplayString(item) + ": ", 1);
          }), 128))]), _createVNode(_component_a_upload, {
            style: {
              "display": "inline-block",
              "width": "auto"
            },
            previewIcon: null,
            showUploadList: {
              showPreviewIcon: true,
              showRemoveIcon: true
            },
            "file-list": upLoadImg.value,
            "onUpdate:file-list": _cache[0] || (_cache[0] = $event => upLoadImg.value = $event),
            "before-upload": beforeUpload,
            customRequest: signUpload,
            "list-type": "picture-card",
            onPreview: reUpload
          }, {
            default: _withCtx(() => [upLoadImg.value.length <= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(PlusOutlined)), _hoisted_5])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["file-list"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_button, {
            onClick: closeModal,
            style: {
              "margin-right": "12px"
            },
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: submitUpload,
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("确认")]),
            _: 1
          }, 8, ["loading"])])])) : signLoads.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.selectedRowKeys, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item,
              style: {
                "margin-bottom": "12px",
                "color": "#000000d9"
              }
            }, [_createTextVNode(_toDisplayString(item) + ": ", 1), _createVNode(_component_a_upload, {
              style: {
                "display": "inline-block",
                "width": "auto"
              },
              showUploadList: {
                showRemoveIcon: true,
                showPreviewIcon: true
              },
              "file-list": upLoadImgs.value[item],
              "onUpdate:file-list": $event => upLoadImgs.value[item] = $event,
              "before-upload": beforeitemUpload,
              customRequest: itemUpload,
              onChange: itemChange,
              "list-type": "picture-card",
              onPreview: reUpload
            }, {
              default: _withCtx(() => [upLoadImgs.value[item].length <= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(PlusOutlined)), _hoisted_9])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["file-list", "onUpdate:file-list"]), upLoadImgs.value[item].length <= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "请使用对应内购 ID 命名文件后再上传")) : _createCommentVNode("", true)]);
          }), 128)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_button, {
            onClick: closeModal,
            style: {
              "margin-right": "12px"
            },
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_a_button, {
            type: "primary",
            onClick: submitUpload,
            loading: spinning.value
          }, {
            default: _withCtx(() => [_createTextVNode("确认")]),
            _: 1
          }, 8, ["loading"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_svg_icon, {
            "icon-class": "screen",
            "class-name": "screen-icon"
          }), _hoisted_15, _hoisted_16]), _createVNode(_component_a_upload_dragger, {
            showUploadList: false,
            "before-upload": beforeUpload,
            "file-list": upLoadImg.value,
            "onUpdate:file-list": _cache[1] || (_cache[1] = $event => upLoadImg.value = $event),
            customRequest: signUpload
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_svg_icon, {
              "icon-class": "upload_stencil",
              "class-name": "upload-icon"
            }), _hoisted_18])]),
            _: 1
          }, 8, ["file-list"])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_svg_icon, {
            "icon-class": "screens",
            "class-name": "screen-icon"
          }), _hoisted_21, _hoisted_22]), _createVNode(_component_a_upload_dragger, {
            showUploadList: false,
            "file-list": upLoadImg.value,
            "onUpdate:file-list": _cache[2] || (_cache[2] = $event => upLoadImg.value = $event),
            multiple: "",
            "before-upload": beforeUpload,
            customRequest: signUploads,
            maxCount: 100
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_svg_icon, {
              "icon-class": "upload_stencil",
              "class-name": "upload-icon"
            }), _hoisted_24])]),
            _: 1
          }, 8, ["file-list"])])])), _createVNode(_component_a_modal, {
            open: previewVisible.value,
            title: previewTitle.value,
            footer: null,
            onCancel: handleCancel
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              alt: "example",
              style: {
                "width": "100%"
              },
              src: previewImage.value
            }, null, 8, _hoisted_25)]),
            _: 1
          }, 8, ["open", "title"])]),
          _: 1
        }, 8, ["spinning"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});